<template>
  <gc-modal condition="true" @cancel="$emit('cancel')" modal-class="gc-modal--wide">
    <template slot="messageTitle"> Add education </template>

    <template slot="body">
      <form ref="form">
        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.school }">
            <label class="form-row__label">School</label>
            <input
              type="text"
              v-model="school.school"
              :maxlength="schoolMaxLength"
              class="title-input-small title-input--border"
              placeholder="Ex: Boston University"
            />
            <div v-if="errors.school" class="form-row__error">{{ errors.school }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.field_of_study }">
            <label class="form-row__label">Field of study</label>
            <input
              type="text"
              v-model="school.field_of_study"
              :maxlength="fosMaxLength"
              class="title-input-small title-input--border"
              placeholder="Ex: Mechanical engineering"
            />
            <div v-if="errors.field_of_study" class="form-row__error">
              {{ errors.field_of_study }}
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item">
            <label class="form-row__label">Degree</label>
            <input
              type="text"
              v-model="school.degree"
              :maxlength="degreeMaxLength"
              class="title-input-small title-input--border"
              placeholder="Ex: Bachelor’s"
            />
            <div v-if="errors.degree" class="form-row__error">
              {{ errors.degree }}
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item">
            <label class="form-row__label">From year</label>
            <select class="input-select" v-model="school.start_year">
              <option :value="null">Year</option>
              <option v-for="(year, yearIndex) in years" :key="yearIndex" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
          <div class="form-row__item">
            <label class="form-row__label">To year (or expected)</label>
            <select class="input-select" v-model="school.end_year">
              <option :value="null">Year</option>
              <option v-for="(year, yearIndex) in years_to" :key="yearIndex" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.description }">
            <label class="form-row__label">Description</label>
            <textarea
              v-model="school.description"
              :maxlength="descriptionMaxLength"
              spellcheck="true"
              class="description-input description-input--xs"
            ></textarea>
            <div v-if="errors.description" class="form-row__error">
              {{ errors.description }}
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button class="gc-modal__delete btn" @click="remove" v-if="school.id">
        <i class="fas fa-times-circle color-red"></i> Delete
      </button>

      <a class="gc-modal__cancel" @click.prevent="$emit('cancel')">Cancel</a>
      <button class="btn btnRed" @click.prevent="save">Save</button>
    </template>
  </gc-modal>
</template>
<script>
import axios from "axios";
import formValidationService from "@/services/formValidationService";

export default {
  name: "EducationModal",
  props: ["modalParams"],
  data() {
    return {
      school: {
        end_year: null,
        start_year: null,
      },
      schoolMaxLength: Grabcad.AttributeLimits.Generic.ORGANISATION_NAME,
      fosMaxLength: Grabcad.AttributeLimits.Generic.TITLE,
      degreeMaxLength: Grabcad.AttributeLimits.Generic.TITLE,
      descriptionMaxLength: Grabcad.AttributeLimits.Generic.CONTENT_DESCRIPTION_LONG,
      errors: {},
    };
  },
  created() {
    this.years = Grabcad.store.years;
    this.years_to = Grabcad.store.years_to;
    this.schools = Grabcad.store.schools;
    let school = this.modalParams.school;

    if (school) {
      this.school = {
        id: school.id,
        school: school.school,
        degree: school.degree,
        end_year: school.end_year,
        start_year: school.start_year,
        description: school.description,
        field_of_study: school.field_of_study,
      };
    }
  },
  computed: {
    requestMethod() {
      return this.school.id ? "put" : "post";
    },
    schoolIds() {
      return this.schools.map(function (s) {
        return s.id;
      });
    },
    selected() {
      return this.schoolIds.indexOf(this.school.id);
    },
  },
  methods: {
    validateForm() {
      this.errors = {};
      const fieldsToValidate = [
        { value: this.school.school, field: "school", label: "School", required: true },
        { value: this.school.field_of_study, field: "field_of_study", label: "Field of study", required: true },
        { value: this.school.degree, field: "degree", label: "Degree" },
        { value: this.school.description, field: "description", label: "Description" },
      ];
      return formValidationService.validateForm(fieldsToValidate, this.errors);
    },
    save() {
      let vm = this;
      if (!vm.validateForm()) return;

      axios
        .request("/profile/educations", {
          method: vm.requestMethod,
          params: { id: vm.school.id },
          data: { school: vm.school },
        })
        .then(function (resp) {
          Array.prototype.splice.call(vm.schools, 0);
          Array.prototype.push.apply(vm.schools, resp.data);
          vm.$emit("cancel");
          vm.showUpdated();
        })
        .catch(function () {
          vm.$emit("cancel");
          vm.showError("Failed to save education!");
        });
    },
    invalid() {
      return !this.$refs.form.checkValidity();
    },
    remove() {
      let vm = this;
      axios
        .request("/profile/educations", {
          method: "delete",
          params: { id: vm.school.id },
        })
        .then(function () {
          vm.schools.splice(vm.selected, 1);
          vm.$emit("cancel");
          vm.showRemoved();
        })
        .catch(function () {
          vm.$emit("cancel");
          vm.showError("Failed to remove education!");
        });
    },
    showError(error) {
      this.$eventHub.$emit("addAlert", { type: "error", message: error });
    },
    showUpdated() {
      this.showFlash("Education successfully saved!");
    },
    showRemoved() {
      this.showFlash("Education successfully removed!");
    },
    showFlash(message) {
      this.$eventHub.$emit("addAlert", { type: "success", message: message });
    },
  },
};
</script>
